export enum Steps {
  S1ContactForm,
  S2VerificationCode,
  S3ConfirmationMessage,
}
